"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CategoryDomainsManager = void 0;
const axios_1 = __importDefault(require("axios"));
const lit_html_1 = require("lit-html");
axios_1.default.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
const typedi_1 = require("typedi");
const loader_1 = require("@common/loader/loader");
const dom_1 = require("@common/utils/dom");
const simple_1 = require("@domain/templates/simple");
const translation_1 = require("@translation/services/translation");
const filters_1 = require("./filters");
const category_1 = require("./category");
const primary_1 = require("@domain/templates/primary");
const achievements_1 = require("@domain/templates/achievements");
const domain_1 = require("@domain/services/domain");
/**
 * Менеджер поиска оп категориям
 */
let CategoryDomainsManager = class CategoryDomainsManager {
    /**
     * Конструктор
     */
    constructor() {
        /**
         * Загрузка
         */
        this.loading = false;
        /**
         * Домены
         */
        this.domains = [];
        /**
         * Ошибка
         */
        this.error = false;
        /**
         * Конец списка
         */
        this.end = false;
        this.domainsFilter = typedi_1.Container.get(filters_1.CategorySearchFilter);
        this.translationService = typedi_1.Container.get(translation_1.TranslationService);
        this.categoryService = typedi_1.Container.get(category_1.CategoryService);
        this.domainService = typedi_1.Container.get(domain_1.DomainService);
    }
    /**
     * Инициализирует состояние
     */
    initialize() {
        return __awaiter(this, void 0, void 0, function* () {
            this.scrollToActiveCategory();
            this.loader = new loader_1.Loader('.js-loader', this.translationService);
            yield this.loadDomains();
            (0, simple_1.registerDomainCardClick)();
            this.registerScrollHandler();
        });
    }
    /**
     * Загружает домены
     */
    loadDomains() {
        return __awaiter(this, void 0, void 0, function* () {
            this.loader.show();
            this.loading = true;
            this.error = false;
            try {
                const { data: { items, ga } } = yield this.categoryService.getCategoryDomains(this.domainsFilter);
                this.pushGA(ga);
                this.domains = [...this.domains, ...items];
                this.end = !items.length;
                yield this.appendDomains(this.domains);
            }
            catch (err) {
                this.renderError(err.message || this.translationService.instant('somethingWentWrong'));
                this.error = true;
            }
            finally {
                this.loader.hide();
                this.loading = false;
            }
        });
    }
    /**
     * Добавляет домены в список
     */
    appendDomains(domains) {
        return __awaiter(this, void 0, void 0, function* () {
            const primaryDomain = domains.filter((item) => item.name === this.domainsFilter.getSearchString());
            let domainsResult = domains;
            if (primaryDomain.length > 0) {
                domainsResult = domains.filter((item) => item.name !== this.domainsFilter.getSearchString());
                this.renderPrimaryDomain(primaryDomain[0]);
                if (domainsResult.length > 1)
                    document.querySelector('.b-domains .similar_domains_subtitle').setAttribute('style', 'display: block');
            }
            else {
                document.querySelector('.b-domains .similar_domains_subtitle').setAttribute('style', 'display: none');
            }
            this.renderCategoryDomains(domainsResult);
        });
    }
    /**
     * Регистрирует обработчик скролла для подгрузки доменов
     */
    registerScrollHandler() {
        const paginator = document.querySelector('.js-search-more-results');
        const domains = paginator ? document.querySelector('.domain') : null;
        if (!paginator || !domains) {
            return;
        }
        const button = paginator.querySelector('button');
        if (button) {
            button.style.display = 'block';
            button.addEventListener('click', () => {
                if (!this.loading && !this.error && (0, dom_1.inViewpoint)(paginator)) {
                    button.style.display = 'none';
                    this.domainsFilter.increaseOffset();
                    this.loadDomains().then(() => { button.style.display = 'block'; });
                }
            });
        }
    }
    /**
     * Генерирует представление доменов категории
     */
    renderCategoryDomains(domains) {
        const container = document.querySelector('.js-category-result-list');
        const searchOptions = document.querySelector('.search-options .option-list');
        const bottomCategoryBlock = document.querySelector('.js-bottom-category-block');
        const btnShowMore = document.querySelector('.js-search-more-results .js-search-more');
        if (!container) {
            return;
        }
        const params = window.location.search;
        if (!domains.length) {
            if (bottomCategoryBlock)
                bottomCategoryBlock.classList.add('hidden');
            if (!params) {
                if (searchOptions)
                    searchOptions.classList.add('hidden');
            }
            else {
                if (searchOptions)
                    searchOptions.classList.remove('hidden');
            }
            if (btnShowMore)
                btnShowMore.setAttribute('style', 'display:none');
            return;
        }
        if (bottomCategoryBlock)
            bottomCategoryBlock.classList.remove('hidden');
        if (btnShowMore)
            btnShowMore.setAttribute('style', 'display:block');
        if (searchOptions)
            searchOptions.classList.remove('hidden');
        const templates = [];
        for (let i = 0; i < domains.length; i++) {
            templates.push((0, simple_1.getSimpleDomainTemplate)(domains[i], this.translationService));
        }
        (0, lit_html_1.render)((0, lit_html_1.html) `${templates}`, container);
        const a = document.querySelector('.js-category-result-list');
    }
    /**
     * Генерирует представление ошибки
     */
    renderError(error) {
        const container = document.querySelector('.js-error-message');
        if (!container) {
            return;
        }
        (0, lit_html_1.render)((0, lit_html_1.html) `
            <div class="search-api-error">${error}</div>
        `, container);
    }
    /**
     * Добавляет слой с данными по доменам в GoogleAnalytics
     */
    pushGA(ga) {
        window.dataLayer.push({ ecommerce: null });
        window.dataLayer.push(ga);
    }
    /**
     * Регистрирует событие клика по меню
     */
    registerClickMenu() {
        const categoryMenu = document.querySelector('.category-menu');
        if (categoryMenu) {
            categoryMenu.addEventListener('click', (e) => {
                const el = e.target;
                if (el.closest('a') && el.nextElementSibling && el.nextElementSibling.nodeName === 'UL') {
                    e.preventDefault();
                    el.nextElementSibling.classList.toggle('active');
                    if (el.nextElementSibling.closest('.dropdown_category'))
                        el.nextElementSibling.closest('.dropdown_category').classList.toggle('active');
                }
            });
        }
        const categoryBtnOpen = document.querySelector('.category-menu-selector');
        if (categoryBtnOpen) {
            categoryBtnOpen.addEventListener('click', (e) => {
                const el = e.target;
                e.preventDefault();
                categoryBtnOpen.closest('.category-wrapper').classList.toggle('open');
                categoryBtnOpen.closest('.category-wrapper').classList.remove('full');
                categoryMenu.scrollTo({ top: 0 });
                this.scrollToActiveCategory();
            });
        }
        const categoryBtnShowMore = document.querySelector('.category-wrapper .js-open-categories');
        if (categoryBtnShowMore) {
            categoryBtnShowMore.addEventListener('click', (e) => {
                const el = e.target;
                e.preventDefault();
                categoryBtnShowMore.closest('.category-wrapper').classList.toggle('full');
            });
        }
    }
    /**
     * Скролит до активной категории меню
     */
    scrollToActiveCategory() {
        const activeMenu = document.querySelector('.category-menu ul li a.active');
        const menuWrapper = document.querySelector('.category-menu');
        if (activeMenu && activeMenu.closest('ul') && activeMenu.closest('ul').previousElementSibling) {
            activeMenu.closest('ul').classList.add('active');
        }
        if (activeMenu && activeMenu.nextElementSibling) {
            activeMenu.nextElementSibling.classList.add('active');
        }
        if (activeMenu && activeMenu.getBoundingClientRect().top > menuWrapper.getBoundingClientRect().height) {
            const top = activeMenu.getBoundingClientRect().top - menuWrapper.getBoundingClientRect().top;
            menuWrapper.scrollTo({ top: top });
        }
    }
    /**
     *
     */
    renderPrimaryDomain(domain) {
        return __awaiter(this, void 0, void 0, function* () {
            const container = document.querySelector('.search-match-result');
            if (!container) {
                return;
            }
            let achievements;
            try {
                const { data } = yield this.domainService.getDomainAchievements(domain.name);
                achievements = data;
            }
            catch (_a) { }
            const achievementsTemplate = (0, achievements_1.getDomainAchievementsTemplate)(achievements, this.translationService);
            (0, lit_html_1.render)((0, primary_1.getPrimaryDomainTemplate)(domain, achievementsTemplate, this.translationService), container);
        });
    }
};
CategoryDomainsManager = __decorate([
    (0, typedi_1.Service)(),
    __metadata("design:paramtypes", [])
], CategoryDomainsManager);
exports.CategoryDomainsManager = CategoryDomainsManager;
